import { Timestamp } from "firebase/firestore";
import { Icon } from "@/components/Common/Icon";
import { firestoreToDateTime, formatDateToMMDDYYWithTime } from "@/lib/utils";

type DueInOutTimeProps = {
  time: string | Date | Timestamp | undefined;
  type: "in" | "out" | "promise";
};
export const DueInOutTime = ({ time, type }: DueInOutTimeProps) => {
  const dateTime = firestoreToDateTime(time);

  if (!dateTime) return null;

  return (
    <div className={"card-text flex flex-row items-center gap-1 opacity-60"}>
      <Icon
        name={
          type === "out"
            ? "dueOut"
            : type === "promise"
              ? "promiseTime"
              : "dueIn"
        }
        size={14}
        className="opacity-50"
      />
      {formatDateToMMDDYYWithTime(dateTime.toISOString())}
    </div>
  );
};
